package com.fantasytenis.shared.domain.engagement.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.domain.engagement.EngagementRepository
import com.fantasytenis.shared.domain.engagement.entity.AchievementEntity

/**
 * Use case for getting all achievement definitions.
 * Updates SharedData.achievements on success.
 */
class GetAchievementsUseCase(
    private val repository: EngagementRepository
) {
    suspend operator fun invoke(): Result<List<AchievementEntity>> = runCatching {
        val achievements = repository.getAchievements()
        // Update shared state
        SharedData.achievements.value = achievements
        achievements
    }
}
